module.exports = __webpack_public_path__ + "static/media/logo.2bf2e2df.gif";